import { Link } from "react-router-dom";

export type Crumb = {
  name: string;
  path?: string;
};

export default function Breadcrumb({
  items,
  tone = "light",
}: {
  items: Crumb[];
  tone?: "light" | "dark";
}) {
  const isDark = tone === "dark";
  return (
    <nav
      aria-label="面包屑导航"
      className={`flex items-center gap-2 text-sm flex-wrap ${
        isDark ? "text-primary-200" : "text-foreground-600"
      }`}
    >
      <i
        className={isDark ? "ri-home-4-line text-primary-300" : "ri-home-4-line text-foreground-500"}
        aria-hidden="true"
      ></i>
      {items.map((item, index) => (
        <span key={`${item.name}-${index}`} className="flex items-center gap-2">
          {item.path ? (
            <Link
              to={item.path}
              className={`transition-colors whitespace-nowrap ${
                isDark ? "hover:text-accent-300" : "hover:text-primary-600"
              }`}
            >
              {item.name}
            </Link>
          ) : (
            <span
              className={`font-medium whitespace-nowrap ${
                isDark ? "text-background-50" : "text-foreground-900"
              }`}
            >
              {item.name}
            </span>
          )}
          {index < items.length - 1 && (
            <i
              className={`ri-arrow-right-s-line ${
                isDark ? "text-primary-400" : "text-foreground-400"
              }`}
              aria-hidden="true"
            ></i>
          )}
        </span>
      ))}
    </nav>
  );
}